import React from 'react'
import { EditPageHeader } from '../../components/EditPageHeader'
import { useState } from 'react'
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE } from '../../framework/constant/constant';
import { toast } from 'react-toastify';
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation';
import { ImageBrowser } from '../../framework/forms/helpercomponents/selectFile/ImageBrowser';
import BossDialog from '../../components/BossDialog';
import { Switch } from '@mui/material';
import moment from 'moment';

const ProviderEditForm = (props) => {

  const lang = useTranslation();
  const blankDataItem = {
    ...props?.item,
    SID: props?.item?.SID ?? 0,
    Description: props?.item?.Description ?? '',
    LogoUrl: props?.item?.LogoUrl ?? '',
    StartDate: props?.item?.StartDate ? utility.convertMilisecondsToDateString(props?.item?.StartDate, 'YYYY-MM-DD') : moment().format("YYYY-MM-DD"),
    EndDate: props?.item?.EndDate ? utility.convertMilisecondsToDateString(props?.item?.EndDate, 'YYYY-MM-DD') : moment().add(7, 'days').format("YYYY-MM-DD"),
    Archive: props?.item?.Archive ?? false,
    IsDefault: props?.item?.IsDefault ?? false,
    IsActive: props?.item?.IsActive ?? false,
    TBA: props?.item?.TBA ?? false,
    DeeplinkUrl: props?.item?.DeeplinkUrl ?? ""
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [imageFiles, setImageFiles] = useState(new Set());

  const isValid = () => {
    if (dataItem.Description == "" || dataItem.Description == undefined) {
      toast.error(`${lang.please_enter_name_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    if (dataItem.LogoUrl == "" || dataItem.LogoUrl == undefined) {
      toast.error(`${lang.please_enter_image_url_error_message}`, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }
    return true;
  }

  const handleSubmit = async () => {

    if (!isValid()) return;

    let LogoUrl = dataItem.LogoUrl;
    if (imageFiles.size > 0) {
      let resUrl = await API.uploadImage(imageFiles);
      if (!resUrl.success) {
        toast.error(`${lang.upload_fail_error_message}`, {
          position: toast.POSITION.TOP_RIGHT
        });
        return;
      }
      LogoUrl = resUrl.data
      dataItem.LogoUrl = LogoUrl
    }

    const data = {
      _id: dataItem?._id,
      SID: dataItem?.SID,
      Description: dataItem?.Description,
      LogoUrl: LogoUrl,
      StartDate: dataItem?.StartDate ? utility.convertStringDatetoMilliseconds(dataItem?.StartDate) : null,
      EndDate: dataItem?.EndDate ? utility.convertStringDatetoMilliseconds(dataItem?.EndDate) : null,
      Archive: dataItem?.Archive ?? false,
      IsDefault: dataItem?.IsDefault ?? false,
      IsActive: dataItem?.IsActive ?? false,
      TBA: dataItem?.TBA ?? false,
      DeeplinkUrl: dataItem?.DeeplinkUrl,
      checkDuplicate: true,
      query: ["Description", "=", dataItem.Description]
    }
    console.log(data)
    let res = await API.saveData(ENTITYNAME.OttProvider, data);
    if (dataItem?.IsDefault) {
      await API.setAsDefault(ENTITYNAME.OttProvider, data._id);
    }
    if (res.success) {
      let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.OTT_PROVIDER, data: res.data, message: res.message };
      API.SaveLogs(logData);
      utility.deleteLocalStorageItem(ENTITYNAME.OttProvider);
      props.cancelEdit();
      props.refresh();
      return;
    } else {
      toast.error(res.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }

  const onChange = (e) => {
    if (e.target.name == 'Archive') {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
    }
    else if (e.target.name == 'IsActive') {
      setDataItem({ ...dataItem, IsActive: !dataItem.IsActive })
    }
    else if (e.target.name === 'TBA') {
      setDataItem({ ...dataItem, TBA: !dataItem.TBA })
    }
    else if (e.target.name == 'IsDefault') {
      setDataItem({ ...dataItem, IsDefault: !dataItem.IsDefault });
    }
    else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    }
  }

  const handleChange = (e) => {
    if (e.target.name === 'LogoUrl' && e.target?.files) {
      if (e.target.files !== undefined) {
        setImageFiles(e.target.files[0]);
      } else {
        setImageFiles(new Set());
      }
    }
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <BossDialog
        title={props.item.Description ?? `${lang.create_provider_dialog_header}`}
        onClose={props.cancelEdit}
        width='700px'
      >
        <EditPageHeader title='' onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
        <div className='row'>
          <div className='col-12'>
            <div className='row mt-2'>
              <div className='col-6'>
                <label htmlFor='Description'>{lang.name_label}*</label>
                <input className="form-control form-control-sm" type='text' name='Description' value={dataItem.Description} onChange={onChange} />
              </div>
              <div className="col-6">
                <label htmlFor="">{lang.deeplink_url_label}</label>
                <input type="text" className="form-control form-control-sm" name="DeeplinkUrl" value={dataItem.DeeplinkUrl} onChange={(e) => onChange(e)} />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <label>{lang.image_url_label} *</label>
                <ImageBrowser name='LogoUrl' value={dataItem.LogoUrl} onChange={handleChange} hidePosterLibrary={true} setSelectedImage={setImageFiles} />
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-5'>
                <label>{lang.start_date_label}</label>
                <input type='date' name='StartDate' className='form-control form-control-sm' value={dataItem.StartDate} onChange={onChange} />
              </div>
              <div className='col-5'>
                <label>{lang.end_Date_label}</label>
                <input type='date' name='EndDate' className='form-control form-control-sm' value={dataItem.EndDate} onChange={onChange} disabled={dataItem.TBA} />
              </div>
              <div className='col-2' style={{ marginTop: "22px" }}>
                <input
                  type='checkbox'
                  name='TBA'
                  checked={dataItem.TBA}
                  value={dataItem.TBA}
                  onClick={onChange}
                  className='mt-1'
                />
                <label className='ml-2'>{lang.tba_label}</label>
              </div>
            </div>
            <div className='row' style={{ marginTop: "17px" }}>
              <div className='col-4' style={{ marginTop: "-6px" }}>
                <Switch
                  name='IsActive'
                  label={lang.status_label}
                  onChange={(e) => onChange(e)}
                  checked={dataItem?.IsActive}
                  value={dataItem?.IsActive}
                  size='medium'
                />
                <label className={dataItem.IsActive ? "pl-1 text-success" : "pl-1 text-danger"}>{lang.active_label}</label>
              </div>
              <div className='col-4'>
                <input type='checkbox'
                  name='Archive'
                  value={dataItem.Archive}
                  checked={dataItem.Archive}
                  onClick={onChange}
                  className='mt-1'
                />
                <label className='ml-2'>{lang.archive}</label>
              </div>
              <div className='col-4'>
                <input
                  type='checkbox'
                  name='IsDefault'
                  value={dataItem.IsDefault}
                  checked={dataItem.IsDefault}
                  onClick={onChange}
                  className='mt-1'
                />
                <label className='ml-2'>{lang.is_default_label}</label>
              </div>
            </div>
          </div>
        </div>
      </BossDialog>
    </div>
  )
}

export default ProviderEditForm
